<template>
  <div class="Repair">
    <div class="Repair-wrapper">
      <div class="header-wrapper common">
        <img src="../../assets/images/village.png">
        <div @click="villageSelect(3)">{{villageName}}</div>
        <button @click="addRepair"><img src="../../assets/images/repair-add.png">新增报修</button>
      </div>
      <div class="date-wrapper common">
        <img src="../../assets/images/repair-left-arrow.png" @click="lastmonth(date_time)">
        <div @click="selectData">{{date_time}}</div>
        <mt-datetime-picker ref="datePicker" type="date" v-model="pickerValue" @confirm="handleConfirm"></mt-datetime-picker>
        <img src="../../assets/images/repair-right-arrow.png" @click="nextmonth(date_time)">
      </div>
      <div class="order-wrapper common">
        <div class="order-type-list">
          <h3>
            <div>报修共计 {{repair_list.all_num}}</div>
            <button class="allcheckbox"><input type="checkbox" id="allcheck"  :checked="isCheckedAll == true" @click="check(isCheckedAll)"><label for="allcheck">全选</label></button>
            <button @click="showFold"><img src="../../assets/images/repair-open-all.png">{{showfold}}</button>
          </h3>
          <div class="type-block-list">
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="r_appoint" :checked="repair_checkeds.indexOf('r1') >= 0" @click="check_r('r1')">
                <label for="r_appoint"><span>未指派</span></label>
                <div class="red">{{repair_list.not_assigned_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="r_accept" :checked="repair_checkeds.indexOf('r2') >= 0" @click="check_r('r2')">
                <label for="r_accept"><span>受理中</span></label>
                <div class="blue">{{repair_list.processing_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="r_finish" :checked="repair_checkeds.indexOf('r3') >= 0" @click="check_r('r3')">
                <label for="r_finish"><span>已完成</span></label>
                <div class="green">{{repair_list.over_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="r_close" :checked="repair_checkeds.indexOf('r4') >= 0" @click="check_r('r4')">
                <label for="r_close"><span>已关闭</span></label>
                <div>{{repair_list.close_num}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-type-list" v-if="showfoldlist">
          <h3>
            <div>到达超时 {{repair_list.timeout_num}}</div>
          </h3>
          <div class="type-block-list">
            <div class="type-block">
              <div class="block word-size">
                <input type="checkbox" id="c_appoint" :checked="clock_checkeds.indexOf('c1') >= 0" @click="check_c('c1')">
                <label for="c_appoint"><span>超时未打卡</span></label>
                <div class="red">{{repair_list.timeout_not_clockin_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="c_accept" :checked="clock_checkeds.indexOf('c2') >= 0" @click="check_c('c2')">
                <label for="c_accept"><span>超时打卡</span></label>
                <div class="orange">{{repair_list.timeout_clockin_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="c_finish" :checked="clock_checkeds.indexOf('c3') >= 0" @click="check_c('c3')">
                <label for="c_finish"><span>未打卡</span></label>
                <div class="blue">{{repair_list.not_clockin_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="c_daka" :checked="clock_checkeds.indexOf('c4') >= 0" @click="check_c('c4')">
                <label for="c_daka"><span>按时打卡</span></label>
                <div class="green">{{repair_list.clockon_num}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-type-list" v-if="showfoldlist">
          <h3>
            <div>全部评价 {{repair_list.all_comments_num}}</div>
          </h3>
          <div class="type-block-list">
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="p_appoint" :checked="evaluate_checkeds.indexOf('e1') >= 0" @click="check_e('e1')">
                <label for="p_appoint"><span>1-2星</span></label>
                <div class="red">{{repair_list.one_two_stars_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="p_accept" :checked="evaluate_checkeds.indexOf('e2') >= 0" @click="check_e('e2')">
                <label for="p_accept"><span>3-4星</span></label>
                <div class="orange">{{repair_list.three_four_stars_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="p_finish" :checked="evaluate_checkeds.indexOf('e3') >= 0" @click="check_e('e3')">
                <label for="p_finish"><span>5星</span></label>
                <div class="green">{{repair_list.five_stars_num}}</div>
              </div>
            </div>
            <div class="type-block">
              <div class="block">
                <input type="checkbox" id="p_pingjia" :checked="evaluate_checkeds.indexOf('e4') >= 0" @click="check_e('e4')">
                <label for="p_pingjia"><span>未评价</span></label>
                <div class="blue">{{repair_list.over_no_evaluation}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="repair-order-wrapper">
        <div class="repair-order-list common" v-for="(repair_details, repair_details_key) in repair_details_list" :key="repair_details_key">
          <div class="repair-order-title" @click="toDetail(repair_details.repair_id)">
            <span class="type_name">{{repair_details.repair_type_name}}-</span>
            <span class="phone_name">{{repair_details.repair_people_name}}</span>
            <span><a :href="'tel:' + repair_details.repair_people_tel"><img class="phone" src="../../assets/images/phone.png"></a></span>
            <span style="flex: 1;text-align: right;">
              <span v-if="repair_details.status == 1">
                <span class="phone_name" style="color: #313131;" v-if="repair_details.is_read == 0">【维修员未读】</span>
                <span class="phone_name green" v-else>【维修员已读】</span>
              </span>
              <span class="red" v-if="repair_details.status == 0">未受理</span>
              <span class="blue" v-else-if="repair_details.status == 1">受理中</span>
              <span v-else-if="repair_details.status == 2">已完成</span>
              <span class="block" v-else-if="repair_details.status == 3">已关闭</span>
            </span>
          </div>
          <div class="repair-order-describe" @click="toDetail(repair_details.repair_id)">{{repair_details.repair_summary}}</div>
          <div class="repair-order-describe" @click="toDetail(repair_details.repair_id)" style="font-size: 14px">
            <span v-if="repair_details.appoint_list.length !== 0">指派：</span>
            <span v-else>未指派</span>
            <span v-for="(appointlist, appointlist_key) in repair_details.appoint_list" :key="appointlist_key" v-if="appointlist.level == 1">{{appointlist.repair_keeper_name}}（主）</span>
            <span v-for="(appointlist, appointlist_key) in repair_details.appoint_list" :key="appointlist_key" v-if="appointlist.level == 2">{{appointlist.repair_keeper_name}}（协）</span>
          </div>
          <div class="repair-order-detail">
            <div class="flex-2" @click="toDetail(repair_details.repair_id)">
              {{repair_details.create_time}}
              <div style="margin-left: 10px;" class="marker_block" :class="repair_details.type_str == '未打卡' ? 'm_blue':' ' && repair_details.type_str == '超时打卡' ? 'm_orange':' ' && repair_details.type_str == '超时未打卡' ? 'm_red':' ' && repair_details.type_str == '按时打卡' ? 'm_green':' '" @click="toDetail(repair_details.repair_id)">{{repair_details.type_str}}</div>
            </div>
            <div @click="toEvaluate(repair_details.repair_id)"><img src="../../assets/images/repair-evaluate.png"></div>
          </div>
          <div class="repair-order-evaluate" v-if="repair_details.evaluate.length !== 0">
            <img class="evaluate-head-img" :src="repair_details.evaluate.head_portrait">
            <div class="evaluate-content">
              <div class="evaluate-title">
                <div>{{repair_details.evaluate.nickname}}</div>
                <div>{{repair_details.evaluate.create_time}}</div>
              </div>
              <div class="evaluate-star"><span v-if="repair_details.evaluate.star_num !== ''">{{repair_details.evaluate.star_num}}星</span><img v-for="(star, star_key) in repair_details.evaluate.star_num" :key="star_key" src="../../assets/images/repair-star.png"></div>
              <div class="evaluate-detail">{{repair_details.evaluate.evaluate_summary}}</div>
              <div class="evaluate-image">
                <img v-for="(image, image_key) in repair_details.evaluate.evaluate_image_id" :key="image_key" :src="image.image_url" @click="previewImage(image.image_url)">
              </div>
            </div>
          </div>
          <div class="repair-order-evaluate" v-for="(comments, comments_key) in repair_details.comments" :key="comments_key">
            <img class="evaluate-head-img" :src="comments.head_portrait">
            <div class="evaluate-content">
              <div class="evaluate-title">
                <div>{{comments.nickname}}</div>
                <div>{{comments.create_date}}</div>
              </div>
              <div class="evaluate-detail">{{comments.content}}</div>
              <div class="evaluate-image">
                <img v-for="(image, image_key) in comments.image_id" :key="image_key" :src="image.image_url" @click="previewImage(image.image_url)">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="see_more" @click="moreClick" class="more">- 点击查看更多 -</div>
    </div>
    <!-- 预览图片 -->
    <div class="previewimg" v-if="previewFile">
      <div @click="previewclose"></div>
      <img :src="previewimg">
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'RepairCenter',
  metaInfo: {
    title: '报修中心'
  },
  data () {
    return {
      loading: false, // 加载动画
      date_time: '',
      pickerValue: new Date(),
      showfold: '收起', // 默认展示
      showfoldflag: 0, // 展示状态
      showfoldlist: true,
      villageShow: false,
      repair_checkeds: ['r1', 'r2', 'r3', 'r4'], // 报修全选
      clock_checkeds: ['c1', 'c2', 'c3', 'c4'], // 打卡全选
      evaluate_checkeds: ['e1', 'e2', 'e3', 'e4'], // 评价全选
      allcheckeds: ['r1', 'r2', 'r3', 'r4', 'c1', 'c2', 'c3', 'c4', 'e1', 'e2', 'e3', 'e4'], // 全选
      isCheckedAll: true, // 全选默认状态
      repair_list: [],
      repair_details_list: [],
      page: 1, // 页码
      page_num: 1,
      see_more: false, // 点击查看更多
      previewimg: '', // 预览图片
      previewFile: false // 预览默认
    }
  },
  computed: {
    ...mapState(['villageName', 'villageId', 'appid', 'openid', 'repairId', 'userId'])
  },
  created () {
    this.loading = true
    this.date_time = this.getDate()
    this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 获取当前时间
    getDate (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      return `${year}-${month}-${day}`
    },
    // 打开时间选择器
    selectData () {
      this.$refs['datePicker'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 上一个天
    lastmonth (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time = y + '-' + m + '-' + d
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextmonth (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time = y + '-' + m + '-' + d
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
      return y + '-' + m + '-' + d
    },
    // 选择时间点击确定按钮
    handleConfirm (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time = resDate
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
    },
    // 选择小区
    villageSelect (e) {
      this.$router.push({name: 'Village', query: {index: e}})
    },
    // 新增报修
    addRepair () {
      this.$router.push({name: 'Repair'})
    },
    // 留言
    toEvaluate: function (repairid) {
      this.$router.push({name: 'Evaluate'})
      this.changeArgs({repairId: repairid})
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 详情
    toDetail: function (repairid) {
      this.$router.push({name: 'RepairDetail'})
      this.changeArgs({repairId: repairid})
    },
    // 点击展示/收起
    showFold: function () {
      if (this.showfoldflag === 0) {
        this.showfold = '展开'
        this.showfoldlist = false
        this.showfoldflag = 1
      } else {
        this.showfold = '收起'
        this.showfoldlist = true
        this.showfoldflag = 0
      }
    },
    getRepairStatistical (check1, check2, check3) {
      let checkr = check1.join(',')
      let checkc = check2.join(',')
      let checke = check3.join(',')
      this.axios.post('/wechat/index/repairStatistical/', {
        village_id: this.villageId,
        user_id: this.userId,
        month: this.date_time,
        type_str_one: checkr,
        type_str_two: checkc,
        type_str_three: checke,
        page: this.page_num
      }).then((res) => {
        if (res.data.status === 1) {
          this.loading = false
          if (res.data.data) {
            this.repair_list = res.data.data
            this.repair_details_list = res.data.data.list

            // 判断列表长度
            if (this.repair_details_list) {
              if (this.repair_details_list.length === res.data.data.count) {
                this.see_more = false
              } else {
                this.see_more = true
              }
            }
          }
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 报修选择
    check_r (checkedId) {
      let repairIndex = this.repair_checkeds.indexOf(checkedId)
      if (repairIndex >= 0) {
        // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
        this.repair_checkeds.splice(repairIndex, 1)
      } else {
        // 选中该checkbox
        this.repair_checkeds.push(checkedId)
      }
      this.isAllCheckeds() // 是否全选
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
    },
    // 打卡选择
    check_c (checkedId) {
      let clockIndex = this.clock_checkeds.indexOf(checkedId)
      if (clockIndex >= 0) {
        // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
        this.clock_checkeds.splice(clockIndex, 1)
      } else {
        // 选中该checkbox
        this.clock_checkeds.push(checkedId)
      }
      this.isAllCheckeds() // 是否全选
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
    },
    // 评价选择
    check_e (checkedId) {
      let evaluateIndex = this.evaluate_checkeds.indexOf(checkedId)
      if (evaluateIndex >= 0) {
        // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
        this.evaluate_checkeds.splice(evaluateIndex, 1)
      } else {
        // 选中该checkbox
        this.evaluate_checkeds.push(checkedId)
      }
      this.isAllCheckeds() // 是否全选
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
    },
    // 是否全选
    isAllCheckeds: function () {
      if (this.repair_checkeds.length + this.clock_checkeds.length + this.evaluate_checkeds.length === this.allcheckeds.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
    },
    // 全选
    check (isCheckedAll) {
      if (isCheckedAll === true) {
        this.isCheckedAll = false
        this.repair_checkeds = []
        this.clock_checkeds = []
        this.evaluate_checkeds = []
      } else {
        this.isCheckedAll = true
        this.repair_checkeds = ['r1', 'r2', 'r3', 'r4']
        this.clock_checkeds = ['c1', 'c2', 'c3', 'c4']
        this.evaluate_checkeds = ['e1', 'e2', 'e3', 'e4']
      }
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
    },
    moreClick () {
      this.page_num = this.page += 1
      this.getRepairStatistical(this.repair_checkeds, this.clock_checkeds, this.evaluate_checkeds)
    }
  }
}
</script>
<style scoped>
.Repair {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.Repair .Repair-wrapper {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.Repair .Repair-wrapper .common {
  padding: 15px 10px;
}
.Repair .Repair-wrapper .header-wrapper {
  display: flex;
  color: #000000;
  font-size: 16px;
  padding: 15px 10px;
}
.Repair .Repair-wrapper .header-wrapper img {
  width: 17px;
  height: 17px;
  vertical-align: top;
  padding: 4px 6px 0 0;
}
.Repair .Repair-wrapper .header-wrapper div {
  flex: 1;
  line-height: 25px;
}
.Repair .Repair-wrapper .header-wrapper button {
  height: 28px;
  line-height: 27px;
  background-color: #ff7c12;
  border-radius: 3px;
  border: none;
  color: #ffffff;
  font-size: 14px;
  padding: 0 10px;
}
.Repair .Repair-wrapper .header-wrapper button img {
  width: 11px;
  height: 11px;
  vertical-align: top;
  padding: 8px 5px 0 0;
}
.Repair .Repair-wrapper .date-wrapper div {
  display: inline-block;
  font-size: 18px;
  color: #313131;
  font-weight: bold;
  line-height: 23px;
  padding: 0 5px;
}
.Repair .Repair-wrapper .date-wrapper img {
  width: 23px;
  height: 23px;
  vertical-align: top;
}
.Repair .Repair-wrapper .order-wrapper {
  padding: 0 10px;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list {
  box-shadow: 0px 1px 0px 0px #f1f1f1;
  padding: 12px 0;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list:last-child {
  box-shadow: none;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list input {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .allcheckbox input:checked+label {
  background-image: url(../../assets/images/allcheck-checked.png);
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .allcheckbox label {
  padding: 1px 0 1px 20px;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/allcheck-unchecked.png);
  background-position: left center;
  background-size: 16px 16px;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list h3 {
  font-size: 18px;
  color: #313131;
  margin: 0;
  display: flex;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list h3 div {
  flex: 1;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list h3 button {
  height: 25px;
  line-height: 23px;
  background-color: #ffffff;
  border-radius: 3px;
  border: none;
  font-size: 16px;
  letter-spacing: 1px;
  color: #000000;
  margin-left: 5px;
  outline: none;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list h3 button img {
  width: 14px;
  height: 14px;
  vertical-align: top;
  padding: 4px 5px 0 0;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list {
  display: flex;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block {
  flex: 1;
  margin-top: 12px;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block .block {
  padding: 7px;
  background-color: #f4f4f4;
  border-radius: 3px;
  margin: 0 2px;
  color: #000000;
  font-size: 12px;
  height: 42px;
  position: relative;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block .block span {
  padding: 8px 0 0 25px;
  display: block;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block .block div {
  font-size: 17px;
  font-weight: bold;
  margin-top: 25px;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block .block input {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block .block input:checked+label {
  background-image: url(../../assets/images/checked.png);
}
.Repair .Repair-wrapper .order-wrapper .order-type-list .type-block-list .type-block .block label {
  background-repeat: no-repeat;
  background-image: url(../../assets/images/unchecked.png);
  background-position: 5px 9px;
  background-size: 16px 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list {
  color: #313131;
  font-size: 15px;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-title {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-title span:last-child {
  letter-spacing: 1px;
  color: #369f3b;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-title .phone {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 1px 8px 0 0;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-title .type_name {
  font-size: 16px;
  letter-spacing: 2px;
  font-weight: bold;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-title .phone_name {
  padding-right: 8px;
  line-height: 19px;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-describe {
  margin: 6px 0 8px 0;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-detail {
  display: flex;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-detail .flex-1 {
  flex: 1;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-detail .flex-2 {
  flex: 2;
  color: #8c8c8c;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-detail div:last-child {
  text-align: right;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-detail img {
  width: 20px;
  height: 20px;
  vertical-align: top;
  padding: 2px 5px 0 0;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate {
  border-top: 1px solid #f1f1f1;
  display: flex;
  padding: 10px 5px 12px 5px;
  margin-top: 10px;
  background-color: #f9f9f9;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-head-img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-right: 10px;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content {
  flex: 1;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-title {
  color: #000000;
  font-weight: bold;
  letter-spacing: 1px;
  display: flex;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-title div:last-child {
  flex: 1;
  color: #8c8c8c;
  text-align: right;
  font-weight: initial;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-detail {
  color: #8c8c8c;
  margin-top: 5px;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-star {
  margin-top: 5px;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-star img {
  width: 15px;
  height: 15px;
  vertical-align: top;
  padding: 2px 5px 0 0;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-star span {
  color: #8c8c8c;
  margin-right: 5px;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-image {
  font-size: 0;
}
.Repair .Repair-wrapper .repair-order-wrapper .repair-order-list .repair-order-evaluate .evaluate-content .evaluate-image img {
  width: 60px;
  height: 60px;
  padding: 8px 8px 0 0;
}
.Repair .Repair-wrapper .word-size {
  font-size: 10px !important;
}
.Repair .Repair-wrapper .more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
.marker_block {
  color: #ffffff;
  padding: 0 9px;
  border-radius: 12px;
  font-size: 14px;
  display: inline-block;
  /* background-color: #f4f4f4; */
}
.marker_block.m_red {
  background-color: #ff5148 !important;
}
.marker_block.m_green {
  background-color: #35c53b !important;
}
.marker_block.m_blue {
  background-color: #25ade0 !important;
}
.marker_block.m_orange {
  background-color: #fa6b2c !important;
}
.Repair .Repair-wrapper .red {
  color: #ff5148 !important;
}
.Repair .Repair-wrapper .green {
  color: #35c53b !important;
}
.Repair .Repair-wrapper .blue {
  color: #25ade0 !important;
}
.Repair .Repair-wrapper .orange {
  color: #fa6b2c !important;
}
.Repair .Repair-wrapper .block {
  color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/RepairCenter.vue